import { AlertTriangle, CheckCircle2, Link2 } from 'lucide-react';

interface InviteNoticeProps {
  tone: 'success' | 'error' | 'warning';
  message: string;
}

const TONE = {
  success: {
    Icon: CheckCircle2,
    className:
      'text-moss-800 dark:text-moss-200 bg-moss-50 dark:bg-moss-900/20 border-moss-200 dark:border-moss-800',
    role: undefined,
  },
  error: {
    Icon: AlertTriangle,
    className:
      'text-clay-800 dark:text-clay-300 bg-clay-50 dark:bg-clay-900/20 border-clay-200 dark:border-clay-800',
    role: 'alert' as const,
  },
  warning: {
    Icon: Link2,
    className:
      'text-[#7A4C0E] dark:text-[#F0C97D] bg-[#FAECD8] dark:bg-[#33260F] border-[#EBC98F] dark:border-[#5C4419]',
    role: 'status' as const,
  },
};

/** Post-submit banner inside the invite drawer body. */
export default function InviteNotice({ tone, message }: InviteNoticeProps) {
  const { Icon, className, role } = TONE[tone];
  return (
    <div
      className={`flex gap-2 items-start text-[12px] border rounded-lg px-3 py-2.5 ${className}`}
      role={role}
    >
      <Icon size={14} className="flex-none mt-0.5" />
      <span>{message}</span>
    </div>
  );
}
